import type { ProjectCreationDraft } from '~/lib/projectCreation'

export function useProjectCreationDraft() {
  return useState<ProjectCreationDraft | null>('project-creation-draft', () => null)
}
